import React, { Component, Fragment } from "react";
import NewPie from "../../../d3Components/NewPieChart/pie";
import ContainerDimensions from "react-container-dimensions";
import * as d3 from "d3";

class PieContainer extends Component {
  state = {
    isLoading: true,
    newPieData: [],
    title: [],
    value: [],
    obj: [],
    newPie: []
  };
  componentDidMount() {
    const newPieData = this.props.newPieData;

    var obj = {};
    for (var i in newPieData) {
      if (!obj[newPieData[i]["fund"]]) {
        obj[newPieData[i]["fund"]] = newPieData[i]["allocation"];
      } else {
        obj[newPieData[i]["fund"]] =
          parseFloat(newPieData[i]["allocation"]) + obj[newPieData[i]["fund"]];
      }
    }
    let arr = [];
    for (let i in obj) {
      arr.push({ label: i, value: obj[i] });
    }
    const title = [],
      value = [];
    for (let i in obj) {
      title.push(i);
      value.push(obj[i]);
    }
    this.setState({
      isLoading: false,
      newPieData: newPieData,
      title: title,
      value: value,
      obj: obj,
      newPie: arr
    });
  }
  render() {
    const { newPieData, obj } = this.state;
    const interpolate = d3.interpolateRgb("#3c4694", "#E8E9F6");
    return (
      <div>
        {newPieData.length ? (
          <div>
            <ContainerDimensions>
              {({ width }) => (
                <Fragment>
                  {width > 0 ? (
                    <NewPie
                      width={width - 40}
                      height={400}
                      id={"Pie99"}
                      color1={"#3c4694"}
                      color2={"#E8E9F6"}
                      data={this.state.newPie}
                    />
                  ) : null}
                </Fragment>
              )}
            </ContainerDimensions>
          </div>
        ) : null}
        {Object.keys(obj).length ? (
          <div className="table-grid">
            {Object.keys(obj).map((d, i) => {
              return (
                <div className="table-grid-row" key={`${d}${obj[d] * i}`}>
                  <div>
                    <span
                      style={{
                        color: interpolate(i / Object.keys(obj).length),
                        fontSize: "20px"
                      }}
                    >
                      ●
                    </span>{" "}
                    {d}{" "}
                  </div>
                  <div>{obj[d].toFixed(2)}%</div>
                </div>
              );
            })}
          </div>
        ) : null}
      </div>
    );
  }
}

export default PieContainer;



// WEBPACK FOOTER //
// ./src/components/pages/Retire/solution/pieContainer.jsx